export function buildNestedSampleFieldUpdates(
  mapField: string,
  sampleKey: string,
  updates: Record<string, unknown>
): Record<string, unknown> {
  const basePath = `${mapField}.${sampleKey}`;
  return Object.fromEntries(Object.entries(updates).map(([key, value]) => [`${basePath}.${key}`, value]));
}
